/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Input, Label, Button, InputCheckbox, CustomLoading, Breadcrumb, SaveIcon, CustonModal } from "../../../Components";

/* 🔗 SERVICE */
import { PermissionsServices } from "../../../Services/permissoesServices";

/* 🧠 REDUX */
import { useSelector } from "react-redux/es/hooks/useSelector";

/* 📁 ASSETS*/
import { Excluir } from "../../../Assets/icons";

/* 🎨 STYLES */
import { Container, TitleContainer, Title, ContainerRow, ContainerColumn, ImageIcon, ButtonsContainer, RowContainer } from "./styles";

/* 🔧 UTILS */
import { isValidField } from "../../../util/validate";

const ViewPermission = () => {
    const { t } = useTranslation();
    
    document.title = t("administrative.sub-items.permissions.view.document-title");

    const navigationFlow =  [
        { text: 'administrative', page: '/adm/permissoes' },
        { text: 'permissions', page: '/adm/permissoes' },
        { text: 'permission', page: null }
    ]

    let { id } = useParams();
    const navigate = useNavigate();
    
    const Services = useRef(new PermissionsServices());
    
    const user = useSelector(state => state.userReducer);
    
    const TitleField = useRef();
    const DescriptionField = useRef();
    const PermissionField = useRef();
    const PrivateCheckbox = useRef();
    
    const TitleValue = useRef();
    const DescriptionValue = useRef();
    const PermissionValue = useRef();
    
    const PrivateValue = useRef();
    
    const [loading, setLoading] = useState(true);
    const [permission, setPermission] = useState([]);
    const [activeModal, setActiveModal] = useState("");

    useEffect(() => {
        const getPermission = async() => {
            setLoading(true);
            let currentPermission = await Services.current.getPermission(id);

            if(currentPermission){
                setPermission(currentPermission);
                try {
                    TitleField.current.getInputDOMNode().value = currentPermission.title;
                    DescriptionField.current.getInputDOMNode().value = currentPermission.description;
                    PermissionField.current.getInputDOMNode().value = currentPermission.permission;
                    PrivateCheckbox.current.getInputDOMNode().value = currentPermission.description;
                } catch (error) {
                    console.log(error);
                }
            }
            setLoading(false);
        }

        try {
            getPermission();
        
        } catch (error) {
            console.log(error);            
        }
    }, [id]);

    // Salva as edições
    const handleSave = async() => {
        if(isValidField(TitleValue.current) && isValidField(DescriptionValue.current)){
            let form = new FormData();
            if(TitleValue.current){form.append('title', TitleValue.current)}
            if(DescriptionValue.current){form.append('description', DescriptionValue.current)}
            if(PermissionValue.current){form.append('permission', PermissionValue.current)}
            form.append('is_private', PrivateValue.current ? 1 : 0);
            form.append('_method', 'PATCH');

            await Services.current.editPermission(id, form);
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    return(
        <>  
            <Container>
                <Breadcrumb flow={navigationFlow}/>
                <TitleContainer>
                    <Title>{permission?.title}</Title>
                </TitleContainer>

                {loading ? <CustomLoading width={'150px'} height={'150px'}/>:
                <>
                    <ContainerRow onSubmit={(e) => e.preventDefault()}>
                        <ContainerColumn>
                            <Label text={t("inputs.title.label")} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='title' 
                                name='title' 
                                type="text" 
                                placeholder= {t("inputs.title.placeholder")}
                                innerRef={TitleField}
                                invalidMessage = {t("inputs.title.invalid-message")}
                                value = {permission?.title}
                                validationFunction = {(text) => isValidField(text)}
                                onchange={(text) => TitleValue.current = text}> 
                            </Input>

                            <Label text={t("inputs.permission.label")} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='permission' 
                                name='permission' 
                                type="text" 
                                placeholder= {t("inputs.permission.placeholder")}
                                innerRef={PermissionField}
                                invalidMessage = {t("inputs.permission.invalid-message")}
                                value = {permission?.permission}
                                validationFunction = {(text) => isValidField(text)}
                                onchange={(text) => PermissionValue.current = text}> 
                            </Input>
                        </ContainerColumn>

                        <ContainerColumn>
                            <Label text={t("inputs.description.label")} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='description' 
                                name='description' 
                                type="text" 
                                placeholder= {t("inputs.description.placeholder")}
                                innerRef={DescriptionField}
                                invalidMessage = {t("inputs.description.invalid-message")}
                                value = {permission?.description}
                                validationFunction = {(text) => isValidField(text)}
                                onchange={(text) => DescriptionValue.current = text}> 
                            </Input>

                            <Label text={'\u00A0'} aling="flex-start"/>
                            <InputCheckbox text={t("checkbox.is-private")} innerRef={PrivateCheckbox} checked={permission?.is_private} onChange={(value)=> {
                                PrivateValue.current = value;
                                return true;
                            }}/>

                        </ContainerColumn>
                    </ContainerRow>

                    <ButtonsContainer>
                        {user?.user?.can?.includes('permission.edit') ?
                            <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={() => handleSave()}/>
                        :<></>}
                        {user?.user?.can?.includes('permission.delete') ?
                            <Button text={t("buttons.delete")} width={'150px'} color={'white-red'} 
                                onClick={() => setActiveModal('delete-permission')} 
                            icon={<ImageIcon src={Excluir}/>}/>
                        :<></>}
                    </ButtonsContainer>
                </>}

            </Container>
            <CustonModal Title={t("modal.delete-permission.title")} Active={activeModal === 'delete-permission'}>
                <RowContainer>
                    <Button width={'fit-content'} text={t("buttons.confirm")} onClick={() => Services.current.deletePermission(id, navigate)}/>
                    <Button $borderRadius={'10px'} text={t("buttons.cancel")} color={'white-red'} onClick={() => setActiveModal('')}> {t("buttons.cancel")} </Button>
                </RowContainer>
            </CustonModal>
        </>
    );
}

export default ViewPermission;